/* import __COLOCATED_TEMPLATE__ from './invoice-component.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { readOnly, union } from '@ember/object/computed';
import { inject as service } from '@ember/service';
export default Component.extend({
  classNames: ['invoice-container'],
  invoice: null,
  appService: service(),
  app: readOnly('appService.app'),
  retrospectivePostSubtotalLineItems: union(
    'invoice.retrospectiveMultiProductDiscountLineItems',
    'invoice.retrospectivePermanentDiscountLineItems',
    'invoice.retrospectiveFixedPriceDiscountLineItems',
    'invoice.retrospectiveCouponLineItems',
    'invoice.retrospectiveVatLineItems',
    'invoice.billAheadPrepaidCreditLineItems',
  ),
  billAheadPostSubtotalLineItems: union(
    'invoice.billAheadMultiProductDiscountLineItems',
    'invoice.billAheadPermanentDiscountLineItems',
    'invoice.billAheadFixedPriceDiscountLineItems',
    'invoice.billAheadCouponLineItems',
    'invoice.billAheadVatLineItems',
  ),
});
